import React, { useState, useEffect } from 'react';
import { routes } from 'constants/config';
import { useFetch } from 'hooks';
import request from 'utils/request_ajax';
import Spinner from 'ui/Spinner';
import AlertBox from 'components/shared/AlertBox';
import StatusLabel from 'components/settings/shared/StatusLabel';

const IlosIntegrationSettings = props => {
  const [ilosAPIKey, setIlosAPIKey] = useState('');
  const [showAlert, setShowAlert] = useState(false);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    if (success) {
      setTimeout(() => {
        setSuccess(false);
      }, 1500);
    }
  }, [success]);

  const { data, loading, error } = useFetch(routes.SETTINGS.INTEGRATIONS);

  useEffect(() => {
    if (error) {
      setShowAlert(true);
    }
    if (data?.ilosAPIKey) {
      setIlosAPIKey(data.ilosAPIKey);
    }
  }, [loading, data, error]);

  const inputChange = event => {
    setIlosAPIKey(event.target.value);
  };

  const onSubmit = async () => {
    try {
      await request.postJSON(routes.SETTINGS.UPDATE_COMPANY, {
        company: {
          settings: {
            ilos_api_key: ilosAPIKey,
          },
        },
      });
      setSuccess(true);
    } catch {
      setShowAlert(true);
      setSuccess(false);
    }
  };

  return (
    <>
      {showAlert && (
        <AlertBox onDismiss={() => setShowAlert(false)}>
          {t('settings.tab.ilos_integration.error_please_refresh')}
        </AlertBox>
      )}
      <div className="row" id="ilos-integration">
        <div className="col-md-12">
          <div className="SettingsContent-section">
            <h3 className="SettingsContent-heading">
              {t('settings.tab.ilos_integration.heading')}
            </h3>
            <hr />
            {loading ? (
              <Spinner />
            ) : (
              <form className="form-horizontal" onSubmit={onSubmit}>
                <div className="SettingsContent-subSection">
                  <p>
                    <label htmlFor="ilos-api-key" className="fw-b">
                      {t('settings.tab.ilos_integration.key_label')}
                    </label>
                    <input
                      placeholder={t(
                        'settings.tab.ilos_integration.key_placeholder',
                      )}
                      value={ilosAPIKey}
                      onInput={inputChange}
                      id="ilos-api-key"
                      className="form-control SettingsContent-fullWidthInput"
                    />
                  </p>
                  <div className="d-f mb-8">
                    <button
                      type="button"
                      className="Button--customColor NewButton"
                      onClick={onSubmit}
                    >
                      {t('settings.tab.ilos_integration.submit')}
                    </button>
                    <StatusLabel success={success} error={error} />
                  </div>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default IlosIntegrationSettings;
